/* Suresh Peddavoora 10/26/2022 3075154998  Removed class for text fields container */
import React, {useContext} from 'react';
import SearchDataManagerContainer from './SearchDataManagerContainer';
import {ThemeContext} from '../../../../../themes/ThemeProvider';

function SearchDataManager({
  setTabValue,
  setCode,
  handleClose,
  setSelectedMediaTypeName,
  mediaName,
  setMediaName,
  setIsCopyData,
  disableCopy,
  setUsageState,
  setDisableCopy,
  usageState,
}) {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();

  return (
    <>
      <div className={handleClose ? `${classes.dialoguecardStyles}` : ` mb-0`}>
        <SearchDataManagerContainer
          setTabValue={setTabValue}
          mediaName={mediaName}
          setMediaName={setMediaName}
          setCode={setCode}
          handleClose={handleClose}
          setSelectedMediaTypeName={setSelectedMediaTypeName}
          setIsCopyData={setIsCopyData}
          disableCopy={disableCopy}
          setDisableCopy={setDisableCopy}
          setUsageState={setUsageState}
          usageState={usageState}
        />
      </div>
    </>
  );
}

export default SearchDataManager;
